<template>
  <aside>
    <slot />
  </aside>
</template>

<script>
export default {
  props: {
    arrowPosition: {
      type: Number,
      default: 20
    }
  }
};
</script>

<style lang="scss" scoped>
aside {
  background: $lightgrey;
  border-radius: 1em;
  padding: 1em 2em;
  margin: 1.5em 0 1em;
  position: relative;
}
</style>
